export interface ICountry {
  value: number
  country: 'pt-br'
  minFraction?: number
  maxFraction?: number
}

export const parseCurrency = ({
  value,
  country,
  minFraction = 2,
  maxFraction = 2
}: ICountry) => {
  return value.toLocaleString(`${country}`, {
    minimumFractionDigits: minFraction,
    maximumFractionDigits: maxFraction
  })
}
export const removeCasasDecimais = (numero: number) => {
  return numero.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
